import React, { useState, useEffect } from 'react';
import './style.css';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { TextField } from '@mui/material';

const FaqAddEdit = ({ faqs, setFaqs, newFaqs, setNewFaqs }) => {

    const handleInputChange = (index, field, value) => {
        const updatedFaqs = [...newFaqs];
        updatedFaqs[index][field] = value;
        setNewFaqs(updatedFaqs);
    };

    const handleExistingInputChange = (index, field, value) => {
        const updatedFaqs = [...faqs];
        updatedFaqs[index][field] = value;
        setFaqs(updatedFaqs);
    };

    const addMoreFaq = () => {
        setNewFaqs([...newFaqs, { question: '', answer: '' }]);
    };

    const handleDelete = (index) => {
        // Remove FAQ at the specified index
        const updatedFaqs = faqs.filter((_, i) => i !== index);
        setFaqs(updatedFaqs);
    };

    const handleNewFaqDelete = (index) => {
        // Remove FAQ from new FAQs array
        const updatedNewFaqs = newFaqs.filter((_, i) => i !== index);
        setNewFaqs(updatedNewFaqs);
    };


    return (
        <div>
            <div style={{ backgroundColor: 'black', height: '2px', marginTop: '1rem' }}></div>
            {faqs.length > 0 ? (
                <div className='mb-4 mt-2'>
                    <h4 className='text-center'><strong>FAQ </strong></h4>
                    {faqs.map((faq, index) => (
                        <div key={index} style={{ marginBottom: '1rem', background: 'whitesmoke', padding: '0.5rem', borderRadius: '0.5rem', boxShadow: '1px 1px whitesmoke', position: 'relative' }}>
                            <h4><strong>Question {index + 1}</strong></h4>
                            <input
                                type="text"
                                className="form-control mb-1"
                                value={faq.question}
                                required
                                placeholder={`Enter Question ${index + 1}`}
                                onChange={(e) => handleExistingInputChange(index, 'question', e.target.value)}
                            />
                            <textarea
                                placeholder={`Enter Answer ${index + 1}`}
                                value={faq.answer}
                                required    
                                multiline
                                rows={4}
                                className='form-control mb-1'
                                onChange={(e) => handleExistingInputChange(index, 'answer', e.target.value)}
                            />
                            <button
                                className="mt-2 design"
                                onClick={() => handleDelete(index)}
                            >
                                <DeleteForeverIcon />
                            </button>
                        </div>
                    ))}
                </div>
            ) : (
                <div>
                    <h2>No FAQs available. Add some below:</h2>
                </div>
            )}
            <div>


                {newFaqs.length > 0 ? (
                    newFaqs.map((faq, index) => (
                        <div key={index} style={{ marginBottom: '1rem', background: 'whitesmoke', padding: '0.5rem', borderRadius: '0.5rem', boxShadow: '1px 1px whitesmoke', position: 'relative' }}>
                        {/* <h4><strong>Question {  (faqs.length + 1) + (newFaqs.length)}</strong></h4> */}
                            <input
                                type="text"
                                className="form-control mb-1"
                                placeholder={`Enter Question ${index + 1}`}
                                value={faq.question}
                                required
                                onChange={(e) => handleInputChange(index, 'question', e.target.value)}
                            />
                            <textarea
                                className="form-control mb-1"
                                placeholder="Enter Answer"
                                value={faq.answer}
                                required
                                rows={4}
                                multiline
                                onChange={(e) => handleInputChange(index, 'answer', e.target.value)}
                            />
                            <button
                                className="mt-2 design"
                                onClick={() => handleNewFaqDelete(index)}

                            >
                                <DeleteForeverIcon />
                            </button>
                        </div>
                    ))
                ) : (
                    // <div>No new FAQs added yet.</div>
                    null
                )}
                <div className='d-flex justify-content-between'>
                    <button className="btn btn-primary" onClick={addMoreFaq}>Add More</button>
                </div>
            </div>
        </div>
    );
};

export default FaqAddEdit;
